import releaseSettings from "../../../config/releaseSettings.js";

const getKey = (base, key) => (
    base[key] ? base[key] : key
);
const extendedBase = (base) => (
{
    ...base,
    Var_Header:                                 getKey(base,"ElT_Header"),
    Var_Banner:                                 getKey(base,"ElT_Banner"),
    Var_Newsletter:                             getKey(base,"ElT_Newsletter"),
    Var_Footer:                                 getKey(base,"ElT_Footer"),
    Var_Product:                                getKey(base,"ElT_Product"),
}
)

export function getTranslationObject(lang) {
    if(!lang || typeof lang !== "string"){
        throw new Error("lang not found");
    }

    const plDefault = {...require(`./pl.json`)};
    let base = {};
    try {
    base = {...require(`./${lang}.json`)};
    } catch (e) {
        console.error(`${`translations/${lang}.json`} were not found, please check translations`);
    }
    const baseWithPlaceholders = releaseSettings.polishPlaceholders ? {...plDefault, ...base} : base;
    return extendedBase(baseWithPlaceholders);
}


// WEBPACK FOOTER //
// ./src/assets/creator/translations/compoundTranslationMapper.js